import React from 'react';
import styled from 'styled-components';
import {
  Globe,
  Users,
  Rocket,
  ChevronRight
} from 'lucide-react'

import { breakpoints } from '@/layouts/breakpoints';

const stories = [
  {
    id: 'remote',
    image: '/about/tt1.jpg',
    stat: 'Remote-first',
    description: 'culture, built around trust and output',
  },
  {
    id: 'global',
    image: '/about/tt3.jpg',
    stat: '12 countries',
    description: 'and counting, across four continents',
  },
  {
    id: 'growth',
    image: '/about/tt2.jpg',
    stat: 'Fast-growing',
    description: 'startup, early enough to make an impact',
  },
];

const StyledComp = styled.div`
  padding: 80px 40px;
  padding-bottom: 120px;
  max-width: 1400px;
  margin: 0 auto;


  @media (max-width: ${breakpoints.small}) {
    padding: 80px 24px;
    padding-bottom: 60px;
  }
  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 32px;

    @media (max-width: ${breakpoints.medium}) {
      flex-direction: column;
    }
  }

  .header-text {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 640px;
  }

  .description {
    font-size: 15px;
    line-height: 1.6;
    color: var(--grey);
    margin: 0;
  }

  .heading {
    font-size: 56px;
    line-height: 1.25;
    font-weight: 400;
    color: rgb(var(--blackr));
    margin: 0;
  }

  .heading strong {
    color: var(--grey);
  }

  .cta {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 18px;
    border-radius: 6px;
    background: rgba(var(--blackr), 0.05);
    color: rgb(var(--blackr));
    font-size: 14px;
    font-weight: 500;
    min-width: 150px;
    border: none;
    cursor: pointer;
    transition: background 0.15s ease;
    align-items: center;

    &:hover {
      background: rgba(var(--blackr), 0.08);
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1px;
    background: rgba(var(--blackr), 0.08);
    border: 1px solid rgba(var(--blackr), 0.08);
    border-radius: 12px;
    overflow: hidden;
  }

  @media (max-width: 900px) {
    .grid {
      grid-template-columns: 1fr;
    }
  }

  .card {
    position: relative;
    height: 600px;
    background-color: rgba(var(--blackr), 0.9);
    background-size: cover;
    background-position: center;
    overflow: hidden;
    svg{
      padding:20px;
    }

    @media (max-width: ${breakpoints.medium}) {
  height: 300px;
    }
    @media (max-width: ${breakpoints.small}) {
      height: 200px;
    }
  }

  .card::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to bottom,
      rgba(var(--blackr), 0.15) 0%,
      rgba(var(--blackr), 0) 35%,
      rgba(var(--blackr), 0) 55%,
      rgba(var(--blackr), 0.75) 100%
    );
  }

  .card-logo {
    position: absolute;
    top: 16px;
    left: 16px;
    z-index: 1;
    height: 22px;
    width: auto;
    display: block;
  }

  .card-copy {
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: 16px;
    z-index: 1;
    color: rgb(var(--whiter));
  }

  .card-stat {
    font-size: 20px;
    font-weight: 600;
    line-height: 1.2;
    margin: 0;
  }

  .card-description {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    margin: 4px 0 0;
    color: rgba(var(--whiter), 0.85);
  }
`;

const Comp = () => {
  const ICONS= [
    <Users color={'blue'}/>,
    <Globe color={'green'}/>,
    <Rocket color={'red'}/>
  ]
  return (
    <StyledComp>
      <div className="header">
        <div className="header-text">
          <h2 className="heading serif">
            Join Our <strong>Mission</strong>
          </h2>
          <p className="description">
            We&rsquo;re always looking for talented individuals who share our
            passion for democratizing financial data and business intelligence. Whether you&rsquo;re an
            engineer, designer, data scientist, or market expert, we&rsquo;d
            love to hear from you.
          </p>
        </div>
        <a href="/jobs" className="cta">
          View open positions <span aria-hidden="true">
            <ChevronRight width={16}/>

          </span>
        </a>
      </div>

      <div className="grid">
        {stories.map((story, i) => (
          <div
            key={story.id}
            className="card"
            style={{ backgroundImage: `url(${story.image})` }}
          >
            {ICONS[i]}
            <div className="card-copy">
              <p className="card-stat">{story.stat}</p>
              <p className="card-description">{story.description}</p>
            </div>
          </div>
        ))}
      </div>
    </StyledComp>
  );
};

export default Comp;
